import { fg } from '@atlassian/jira-feature-gating';

const JsmIncidentCommandCenterIncidentTimelineRelayProvider = {
	get(): boolean {
		return fg('jsm_incident_command_center_incident_timeline');
	},
};

export default JsmIncidentCommandCenterIncidentTimelineRelayProvider;
